import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useRegistration} from '../hooks/useRegistration';
import {Registration} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useRegistration();

    return (
        <FormDrawer
            record={{
                id: '',
                productCode: '',
                customerIdentifier: '',
                customerAWSAccountId: '',
                marketplaceToken: '',
            } as unknown as Registration}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
